import { takeEvery, put, call } from "redux-saga/effects";
import { UPLOAD_FILE_REQUEST } from "./UploadCsvTypes";
import { uploadFileSuccess, uploadFileFailure } from "./UploadCsvAction";
import axiosInstance from "../instance/AxiosInstance";

const uploadFileAPI = async (file, type) => {
  const endpoints = {
    customer: "/customers/bulkinsertcustomers",
    vendor: "/vendors/bulkinsertvendors",
    services: "/services/bulkservice",
    airports: "/airports/bulkairport",
    staffs: "/staffs/bulkinsertstaff"
  };

  const url = endpoints[type];

  if (!url) {
    throw new Error(`Invalid upload type: ${type}`);
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response.data;
};

function* uploadFileSaga(action) {
  try {
    const { file, type } = action.payload;
    if (!file) {
      throw new Error("No file selected");
    }

    if (!file.name.toLowerCase().endsWith(".csv")) {
      throw new Error("Only CSV files are allowed");
    }

    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      throw new Error("File size exceeds 5MB limit");
    }

    const data = yield call(uploadFileAPI, file, type);
    yield put(uploadFileSuccess(data, type));
  } catch (error) {
    let detailedErrorMessage = "Upload failed. Please try again.";

    if (
      error.message === "Invalid upload type" ||
      error.message === "No file selected" ||
      error.message === "Only CSV files are allowed" ||
      error.message === "File size exceeds 5MB limit"
    ) {
      detailedErrorMessage = error.message;
    } else if (error.response) {
      const errorMessage =
        error.response?.data?.message || "Upload failed. Please try again.";
      const errorFields = error.response?.data?.errorFields;

      detailedErrorMessage = errorMessage;
      if (errorFields) {
        const fieldErrors = Object.entries(errorFields)
          .map(([field, message]) => `${field}: ${message}`)
          .join(", ");
        detailedErrorMessage += ` (${fieldErrors})`;
      }
    }

    yield put(
      uploadFileFailure(
        detailedErrorMessage,
        error.response?.data?.errorFields,
        action.payload.type
      )
    );
  }
}

export function* watchUploadFile() {
  yield takeEvery(UPLOAD_FILE_REQUEST, uploadFileSaga);
}
